export enum VagaStatusEnum {
    INICIADA = 'INICIADA',
    PUBLICADA = 'PUBLICADA',
    ENCERRADA = 'ENCERRADA'
}
